(function () {
  'use strict';

  if (typeof gsap === 'undefined') return;

  var plugins = [];
  if (typeof MotionPathPlugin !== 'undefined') plugins.push(MotionPathPlugin);
  if (typeof ScrollTrigger !== 'undefined') plugins.push(ScrollTrigger);
  if (typeof SplitText !== 'undefined') plugins.push(SplitText);
  if (typeof ScrollSmoother !== 'undefined') plugins.push(ScrollSmoother);

  if (plugins.length) {
    gsap.registerPlugin.apply(gsap, plugins);
  }

  if (
    typeof ScrollSmoother !== 'undefined' &&
    document.documentElement.dataset.tsScrollSmoother === 'true'
  ) {
    ScrollSmoother.create({
      smooth: 1.25,
      effects: true
    });
  }
})();
